import React from 'react';

import logo from './logo.svg';
import './App.css';
import MainPage from './components/mainpage/mainpage';
import Header from './components/header/header';
import Footer from './components/footer/footer';
import About from './components/aboutus/about';
import Blog from './components/blog/blog'; 
import Feedback from './components/feedback/feedback'; 
import TbtPage from './components/tbt/tbt'; 
import FencingCamp from './components/fencingcamp/fencingcamp'; 
import Contact from './components/contact/contact'; 
import { Link } from 'react-router-dom';
import Page404 from './components/page404/page404';

import {Route, Routes } from 'react-router-dom';
import CoachesPage from './components/coaches/coaches';
function App() {

  return  <div>
  
      <Header />
      <Routes>
  
			<Route path="/" element={<MainPage />} />
			<Route path="/about" element={<About />} />
			<Route path="/tbt" element={<TbtPage />} />
			<Route path="/feedback" element={<Feedback />} />
			<Route path="/coaches" element={<CoachesPage />} />
			<Route path="/blog" element={<Blog />} />
			<Route path="/contact" element={<Contact />} />
			<Route path="/fencingcamp" element={<FencingCamp />} />
			<Route path="*" element={<Page404 />} />

      </Routes>



      </div>
  ;
}

export default App;


